import Socket from '../connection/socket';
import { getState } from './socket-listener-main';
import { showAlert } from '../components/general-components/alert-service';

export default function Sip(socket: Socket) {
	const {
		SessionReducer: {
			host,
		},
	} = getState();

	if (host) {
		socket.addListener('sip-connection-error', (message: { message: { error: string } }) => {
			showAlert({
				message: 'SIP Connection Failed',
				description: message?.message?.error || 'Failed to establish connection',
				duration: 6000,
				type: 'error',
			});
		});
	}
}
